import { render, staticRenderFns } from "./AccessoryItem.vue?vue&type=template&id=fd8f0992&scoped=true&"
import script from "./AccessoryItem.vue?vue&type=script&lang=js&"
export * from "./AccessoryItem.vue?vue&type=script&lang=js&"
import style0 from "./AccessoryItem.vue?vue&type=style&index=0&id=fd8f0992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8f0992",
  null
  
)

export default component.exports